module.exports = __webpack_public_path__ + "static/img/fz_xe_tb.e131c52.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_xe_tb.png
// module id = vGX5
// module chunks = 0